import moment from 'moment';
import { closedDispatchToReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const closedDispatch = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Despachos_cerrados_según_antigüedad.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Id. de envío',
        name: 'dispatchId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w130',
        value: (element: closedDispatchToReport) => element.dispatchId
      },
      {
        title: 'Origen',
        name: 'origin',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: closedDispatchToReport) => element.origin
      },
      {
        title: 'Compañía',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: closedDispatchToReport) => element.companyCode
      },
      {
        title: 'Tipo de entidad',
        name: 'entityType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: closedDispatchToReport) => element.entityType
      },
      {
        title: 'Creado',
        name: 'createdAt',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: closedDispatchToReport) => element.createdAt
      },
      {
        title: 'Actualizado',
        name: 'updatedAt',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: closedDispatchToReport) => element.updatedAt
      },
      {
        title: 'Descripción de la demora actualizada',
        name: 'dispatchUpdatedDelayDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: closedDispatchToReport) => element.dispatchUpdatedDelayDescription
      },
      {
        title: 'Estado del viaje',
        name: 'tripState',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: closedDispatchToReport) => element.tripState
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: closedDispatchToReport) => moment(element.deliveryDate).format('YYYY-MM-DD')
      },
      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: closedDispatchToReport) => element.total
      },
    ],
    subTable: {}
  };
